import React from 'react';
import {Layers, useLayer} from '@craftjs/layers';

import EditorLayersHeader from './Editor.Layers.Header';

/*
Reference:
https://github.com/prevwong/craft.js/blob/main/packages/layers/src/layers/DefaultLayer/DefaultLayer.tsx
*/

interface IEditorLayersProps {}

const EditorLayers = ({}: IEditorLayersProps) => {
  return <Layers renderLayer={CustomLayer} />;
};

const CustomLayer = ({children}: {children?: React.ReactNode}) => {
  const {
    connectors: {layer},
  } = useLayer();
  return (
    <div
      ref={dom => {
        dom && layer(dom);
      }}>
      <EditorLayersHeader />
      {children ? <div className="craft-layer-children">{children}</div> : null}
    </div>
  );
};

export default React.memo(EditorLayers);
